import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    height: theme.spacing(4),
  },
}));
